<!--
 * @Description: 本地时间于北京时间相隔太久提示页面
 * @Version: 0.1
 * @Autor: fengjinxu
--> 
<template>
  <div class="wrap">
    <div class="content">
      <p class="content-title">
        提示：亲爱用户您好，由于本地电脑时间和准确的北京时间差别太大会影响系统功能正常使用，请修改正确时间方便使用，电脑各winow系统时间修改方法如下：
      </p>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="windows7,8系统时间修改方法">
          <p></p>

          <div class="item">
            <p class="title">1.鼠标右键点击桌面右下脚的时间，点击弹出框的【调整日期/时间】</p>
            <div class="item-content">
              <img src="@/assets/timeTips/701.jpg" alt="" />
            </div>
          </div>
          <div class="item">
            <p class="title">2.点击弹出框中的更改日期和时间</p>
            <div class="item-content">
              <img src="@/assets/timeTips/702.jpg" alt="" />
            </div>
          </div>
          <div class="item">
            <p class="title">
              3.在时间和日期设置界面点击左框修改日期，右侧可以修改时间，请按照准确的北京时间修改 点击确定
            </p>
            <div class="item-content">
              <img src="@/assets/timeTips/703.jpg" alt="" />
            </div>
          </div>

          <div class="item">
            <p class="title">4. <span>关闭</span>浏览器当前页面<span>重新打开</span>开票系统即可成功进入</p>
          </div>

          <!-- <div class="item" style="text-align: center">
            <a-button type="primary" @click="reload" size="large" :icon="icon"> {{ buttonText }} </a-button>
          </div> -->
        </a-tab-pane>
        <a-tab-pane key="2" tab="windows10系统时间修改方法" force-render>
          <div class="item">
            <p class="title">1.鼠标右键点击桌面右下脚的时间</p>
            <div class="item-content">
              <img src="@/assets/timeTips/001.png" alt="" class="img" />
            </div>
          </div>
          <div class="item">
            <p class="title">2.点击弹出框的【调整日期/时间】</p>
            <div class="item-content">
              <img src="@/assets/timeTips/002.png" alt="" class="img" />
            </div>
          </div>
          <div class="item">
            <p class="title">
              3.打开自动设置时间，系统会自动匹配网络北京时间，如有成功修改，请直接按照第5步骤完成操作
            </p>
            <div class="item-content">
              <img src="@/assets/timeTips/003.png" alt="" class="img" />
            </div>
          </div>

          <div class="item">
            <p class="title">
              4.如果自动设置时间无效，请按下图手动修改正确时间
            </p>
            <div class="item-content">
              <img src="@/assets/timeTips/004.png" alt="" class="img" />
            </div>
          </div>

          <div class="item">
            <p class="title">5. <span>关闭</span>浏览器当前页面<span>重新打开</span>开票系统即可成功进入</p>
          </div>
          <!-- <div class="item" style="text-align: center">
            <a-button type="primary" @click="reload" size="large" :icon="icon"> {{ buttonText }} </a-button>
          </div> -->
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
// import demo from '@/demo/demo'
export default {
  name: 'TimeTips',
  data() {
    return {
      icon: 'check', //loading
      buttonText: '我已修改完成', //
    }
  },
  created() {},
  mounted() {},
  watch: {
    //deep:true深度监听，可监听到对象、数组的变化
    // info:{
    //     handler(val, oldVal){
    //         console.log("info.name: "+val.name, oldVal.name)
    //     },
    //     deep:true
    // }
  },
  methods: {
    reload() {
      this.icon = 'loading'
      this.buttonText = '正在进入系统请稍后...'
      this.$emit('reload')
    },
  },
}
</script>

<style lang="less" scoped>
// @import "@/assets/css/com.scss";
.wrap {
  height: 100%;
  background: #f5f5f5;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  .content-title {
    margin-bottom: 30px;
    text-align: left;
    font-size: 16px;
    color: #ed7b06d9;
  }
  .content {
    width: 1000px;
    background: #fff;
    margin: auto;
    padding: 40px;
    .item {
      margin-top: 30px;
      .title {
        font-size: 14px;
        font-weight: bold;
        span {
          color: red;
        }
      }
      .img {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>